export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14079.a33ca304.jpg";